import { z } from "zod";
import type { Ppe, PpeRequestStatus } from "../../utils";

const ppeStatusEnum = ["pending", "approved", "refused", "todo", "to_validate"] as const satisfies PpeRequestStatus[];
const ppeEquipmentEnum = [
  "hearing_protection_helmet",
  "protective_glasses",
  "protective_gloves",
  "safety_helmet",
  "safety_vest",
  "safety_pants",
  "safety_shoes",
  "comfort_parka",
  "comfort_polar_vest",
  "comfort_earplugs",
] as const satisfies Ppe[];

const ppeItemSchema = z.object({
  ppe_item: z.object({
    equipment: z.enum(ppeEquipmentEnum),
    label_fr: z.string(),
  }),
  attribute: z.string(),
});

export const ppeRequestsDetailsSchema = z.object({
  id: z.string(),
  status: z.enum(ppeStatusEnum),
  created_at: z.string(),
  ppe_comments: z.string().nullable(),
  contract: z.object({ contract_key: z.number() }),
  ppes: z.array(ppeItemSchema),
});

export const ppeRequestFromTalentSchema = z.object({
  contract_key: z.number(),
  ppes: z.array(
    z.object({
      attribute: z.string(),
      ppe_item_id: z.string(),
    })
  ),
});

export const ppeRequestResponseSchema = z.object({
  contract_id: z.string(),
  created_at: z.string(),
  created_by: z.string().nullable(),
  id: z.string(),
  owner_id: z.string().nullable(),
  ppe_comments: z.string().nullable(),
  price: z.number().nullable(),
  status: z.enum(ppeStatusEnum),
  talent_id: z.string(),
  updated_at: z.string().nullable(),
  updated_by: z.string().nullable(),
  workspace_id: z.string(),
  wsm_id: z.string().nullable(),
  is_created_from_app: z.boolean(),
});

const pickupLocations = [
  "paris_vetiwork",
  "paris_asap",
  "ingre_epi_du_centre",
  "toulouse_epi_haute_visibilite_nord_sud",
  "other_shops",
] as const;

export const ppeRequestEmailSchema = z.object({
  talent_id: z.string(),
  ppe_request_id: z.string(),
  pickup_location: z.enum(pickupLocations),
  wsm_comment: z.string().optional(),
  cc_user_ids: z.array(z.string()).optional(),
});

export type PpeRequestEmail = z.infer<typeof ppeRequestEmailSchema>;

export const ppeRequestApprovalBodySchema = z.object({
  price: z.number(),
  wsm_id: z.string().nullable(),
});
